export default "/images/photo-card.png?2c2909f6b0cf9fea2413de604f2f4adc";